import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateHolidayStatusMutationCgResponse,
  UpdateHolidayStatusMutationVariables,
  UpsertHolidayMutationCgResponse,
  UpsertHolidayMutationVariables,
} from '@common/graphql/schema';
import { TimekeepingHoliday } from '@timekeeping/graphql';

export const UpdateHolidayStatus: TypedDocumentNode<
  UpdateHolidayStatusMutationCgResponse,
  UpdateHolidayStatusMutationVariables
> = gql`
  mutation UpdateHolidayStatus($id: ID!, $status: String!) {
    update: worksTimekeepingUpdateHolidayStatus(id: $id, status: $status) {
      holiday {
        ...TimekeepingHoliday
      }
      errors
    }
  }
  ${TimekeepingHoliday}
`;

export const UpsertHoliday: TypedDocumentNode<
  UpsertHolidayMutationCgResponse,
  UpsertHolidayMutationVariables
> = gql`
  mutation UpsertHoliday($id: ID, $input: WorksTimekeepingUpdateHolidayInput!) {
    update: worksTimekeepingUpsertHoliday(id: $id, input: $input) {
      holiday {
        ...TimekeepingHoliday
      }
      errors
    }
  }
  ${TimekeepingHoliday}
`;
